/**
 * @generated SignedSource<<9a353b184b81e35567ba39af0d7c5eab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type RecordIcon_ToggleMutation$variables = {
  eventGuid: string;
  value: boolean;
};
export type RecordIcon_ToggleMutation$data = {
  readonly toggleEventSchedulingMeetingAssistantAutomation: {
    readonly event: {
      readonly guid: string;
      readonly id: string;
      readonly stream: {
        readonly id: string;
        readonly schedulingMeetingAssistantAutomationIsActive: boolean;
      } | null;
      readonly willBeRecorded: WillBeRecordedType;
    };
  } | null;
};
export type RecordIcon_ToggleMutation = {
  response: RecordIcon_ToggleMutation$data;
  variables: RecordIcon_ToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventGuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "eventGuid",
        "variableName": "eventGuid"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "ToggleEventSchedulingMeetingAssistantAutomation",
    "kind": "LinkedField",
    "name": "toggleEventSchedulingMeetingAssistantAutomation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "willBeRecorded",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingMeetingAssistantAutomationIsActive",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecordIcon_ToggleMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecordIcon_ToggleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bd612d1000c45e2202a4dad59d7b248b",
    "id": null,
    "metadata": {},
    "name": "RecordIcon_ToggleMutation",
    "operationKind": "mutation",
    "text": "mutation RecordIcon_ToggleMutation(\n  $eventGuid: String!\n  $value: Boolean!\n) {\n  toggleEventSchedulingMeetingAssistantAutomation(eventGuid: $eventGuid, value: $value) {\n    event {\n      id\n      guid\n      willBeRecorded\n      stream {\n        id\n        schedulingMeetingAssistantAutomationIsActive\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0955c0c0070d4572c1b44e247e76c575";

export default node;
